import { LANDING_FEATURES } from '../content/landingFeatures';
import { FeatureSection } from './FeatureSection';

export function FeatureShowcase() {
  return (
    <div id="features" className="border-t border-neutral-soft bg-background-light max-md:border-t-0">
      {LANDING_FEATURES.map((feature, index) => (
        <FeatureSection
          key={feature.id}
          feature={feature}
          reverse={index % 2 === 1}
          isLast={index === LANDING_FEATURES.length - 1}
        />
      ))}
    </div>
  );
}
